import React from "react";
import $ from "jquery";
import TopNav from "../../commonUI/TopHeader/TopHeader";
import { showSpinner, modal, closeSpinner } from "../../../js/modules/Dialogs";
import { signInFailTooManyAttempts } from "../../../config/messages";
import { signInUser } from "../../../services/authService";
import PropTypes from 'prop-types';
import { toScreen } from "../../../js/modules/Routing";
import withNavigate from "../withNavigate";
class SignIn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      otp: "",
      otpSent: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  signInUser = async (event) => {
    event.preventDefault();

    const theUser = {
      email: this.state.email,
      password: this.state.password,
    };
    const theUserWith2FA = {
      email: theUser.email,
      password: theUser.password,
      otp: this.state.otp,
    };

    this.setState({
      email: theUser.email,
      password: theUser.password,
      otp: this.state.otp,
    });

    if (
      (!this.state.otpSent && this.state.email && this.state.password) ||
      (this.state.otpSent && this.state.otp)
    ) {
      showSpinner();
      try {
        const response = await signInUser(
          !this.state.otpSent ? theUser : theUserWith2FA
        );
        closeSpinner();

        if (this.state.otpSent) {
          const userDetails = { ...this.props.userDetails };
          userDetails.jwttoken = response.jwttoken;
          userDetails.accountInfo = { ...response.accountInfo };
          userDetails.myJobs = { ...response.myJobs };
          userDetails.myQuotes = { ...response.myQuotes };
          userDetails.messages = response.messages;
          userDetails.userType = response.userType;
          userDetails.short_id = response.short_id;

          this.props.updateState("userDetails", userDetails);
          toScreen(false, this.props.navigate, "/");
        } else {
          modal("OTP sent");
          this.setState({ otpSent: true });
        }
      } catch (error) {
        closeSpinner();
        const errorMessage = error.response?.data?.message || error.message || "Sign in failed";
        modal(errorMessage);
      }
    } else {
      if (
        !this.state.otpSent &&
        (this.state.email === "" || this.state.password === "")
      ) {
        modal("Enter email and password");
      } else if (this.state.otpSent && this.state.otp === "") {
        modal("Enter valid OTP");
      } else {
        modal("Something went wrong, Try again!");
      }
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  render() {
    if (
      this.props.userDetails.jwttoken != null &&
      this.props.userDetails.accountInfo.username != null
    ) {
      return (
        <>
          <TopNav title={"Sign In"}/>
          <div className="global-body">
            <div className="global-body-container">
              <div className="l-row">
                <div className="l-col-66">
                  <p>
                    You are already signed in as:{" "}
                    {this.props.userDetails.accountInfo.username}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
        <TopNav title={"Sign In"}/>
          <div className="global-body">
            <div className="global-body-container">
              <div className="l-row">
                <div className="l-col-66">
                  <form onSubmit={(e) => this.signInUser(e)}>
                    {!this.state.otpSent && (
                      <div>
                        <div className="c-input-wide">
                          <label className="c-input-wide__label">Email:</label>
                          <input
                            type="text"
                            value={this.state.email}
                            onChange={this.handleInputChange}
                            name="email"
                            placeholder="Email"
                            className="c-input-wide__input"
                          />
                        </div>

                        <div className="c-input-wide">
                          <label className="c-input-wide__label">Password:</label>
                          <input
                            type="password"
                            value={this.state.password}
                            onChange={this.handleInputChange}
                            name="password"
                            placeholder="Password"
                            className="c-input-wide__input"
                          />
                        </div>
                      </div>
                    )}
                    {this.state.otpSent && (
                      <div className="c-input-wide">
                        <label className="c-input-wide__label">
                          2FA authentication:
                        </label>
                        <input
                          type="password"
                          value={this.state.otp}
                          onChange={this.handleInputChange}
                          name="otp"
                          placeholder="Auth code"
                          className="c-input-wide__input"
                        />
                      </div>
                    )}
                  </form>
                </div>
                <div className="l-col-33">
                  <button
                    className="c-btn c-btn--small c-btn--full-width u-margin-bottom-xs"
                    onClick={(e) => this.signInUser(e)}
                  >
                    SignIn
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }
}

SignIn.contextTypes = {
  router: PropTypes.object,
};

SignIn.propTypes = {
  userDetails: PropTypes.object.isRequired,
  updateState: PropTypes.func.isRequired,
};

export default withNavigate(SignIn);
